/**
 * Caption editor sub-components.
 * Extracted so the visual-edits babel plugin doesn't choke on complex
 * inline map/JSX in AutoCaptionsPage.js.
 */
import React from "react";

function alphaHex(value) {
  const clamped = Math.max(0, Math.min(1, Number(value) || 0));
  return Math.round(clamped * 255).toString(16).padStart(2, "0");
}

export function PresetCard({ preset, selected, onSelect }) {
  const prev = preset.preview || {};
  const fontFamily = (prev.font || "FreeSans").replace(/\[.*\]/g, "").trim();
  const hasBox = prev.box === "solid";
  const bgRgba = hasBox ? `${prev.box_color}${alphaHex(prev.box_opacity)}` : "transparent";
  const textShadow = prev.outline_color
    ? `0 0 2px ${prev.outline_color}, 0 0 2px ${prev.outline_color}, 0 1px 2px ${prev.outline_color}`
    : undefined;

  return (
    <button
      type="button"
      className="ac-preset"
      data-selected={selected}
      onClick={() => onSelect(preset.key)}
      data-testid={`ac-preset-${preset.key}`}
    >
      <div
        className="ac-preset-thumb"
        data-position={prev.position}
        style={{ background: "#111" }}
      >
        <span
          style={{
            fontFamily: `"${fontFamily}", "Segoe UI", sans-serif`,
            color: prev.text_color,
            background: bgRgba,
            textTransform: prev.uppercase ? "uppercase" : "none",
            textShadow,
            fontWeight: 900,
            padding: hasBox ? "2px 6px" : 0,
          }}
        >
          Aa <span style={{ color: prev.highlight_color }}>Bb</span>
        </span>
      </div>
      <div>
        <p className="ac-preset-name">{preset.name}</p>
        <p className="ac-preset-desc">{preset.description}</p>
      </div>
    </button>
  );
}

/**
 * Editable word pill with inline delete affordance.
 */
export function WordChip({ index, word, onEdit, onDelete }) {
  return (
    <span className="ac-word-wrap" data-testid={`ac-word-wrap-${index}`}>
      <span
        className="ac-word"
        contentEditable
        suppressContentEditableWarning
        onBlur={(e) => onEdit(index, e.currentTarget.textContent || "")}
        data-testid={`ac-word-${index}`}
      >
        {word}
      </span>
      <button
        type="button"
        className="ac-word-del"
        onClick={() => onDelete(index)}
        aria-label={`Delete word ${word}`}
        data-testid={`ac-word-del-${index}`}
      >
        ×
      </button>
    </span>
  );
}
